import React from "react";
import { createUseStyles } from "react-jss";
import useHover from "../../../lib/player/src/hooks/useHover";

const AltImage = ({ image, onDelete, onOpen }) => {
  const [ref, hovering] = useHover();
  const classes = useStyles({ hovering });

  return (
    <div className={classes.alt} ref={ref}>
      {hovering ? (
        <>
          <button
            onClick={evt => {
              evt.stopPropagation();
              onOpen();
            }}
          >
            Open
          </button>
          {onDelete && (
            <button onClick={() => onDelete(image.id)}>Delete</button>
          )}
        </>
      ) : (
        <>
          <img src={image.urls.low} alt={image.name} />
          <div className={classes.altInfo}>
            <p className={classes.altName}>{image.name}</p>
            <p className={classes.altTag}>{image.tag}</p>
          </div>
        </>
      )}
    </div>
  );
};

const useStyles = createUseStyles(theme => ({
  alt: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    boxSizing: "border-box",
    justifyContent: props => (props.hovering ? "space-between" : "flex-start"),
    alignItems: "center",
    margin: [2, 0],

    "& button": {
      width: "calc(50% - 2.5px)",
      border: "none",
      backgroundColor: theme.colorRed,
      color: "white",
      cursor: "pointer",
      height: 40,
      borderRadius: 3,
    },
    "& img": {
      height: 40,
      width: "50px !important",
      objectFit: "cover",
      borderRadius: 2,
    },
  },
  altInfo: {
    lineHeight: "initial",
    color: "white",
    marginLeft: 5,
  },
  altName: {
    margin: 0,
    fontWeight: "bold",
  },
  altTag: {
    margin: 0,
    color: "white",
  },
}));

export default AltImage;
